import { AuthModel } from './_models'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

// Store logout callback function
let logoutCallback: (() => void) | null = null

// Function to register logout callback
const setLogoutCallback = (callback: () => void) => {
    logoutCallback = callback
}

// Function to clear logout callback
const clearLogoutCallback = () => {
    logoutCallback = null
}
const getAuth = (): AuthModel | undefined => {
    if (!localStorage) {
        return
    }

    const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
    if (!lsValue) {
        return
    }

    try {
        const auth: AuthModel = JSON.parse(lsValue) as AuthModel
        if (auth) {
            // You can easily check auth_token expiration also
            return auth
        }
    } catch (error) {
        console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
    }
}

const setAuth = (auth: AuthModel) => {
    if (!localStorage) {
        return
    }

    try {
        const lsValue = JSON.stringify(auth)
        localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
    } catch (error) {
        console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
    }
}

const removeAuth = () => {
    if (!localStorage) {
        return
    }

    try {
        localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
    } catch (error) {
        console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
    }
}

export function setupAxios(axios: any) {
    axios.defaults.headers.Accept = 'application/json'

    // Request interceptor to add authorization header
    axios.interceptors.request.use(
        (config: { headers: { Authorization: string } }) => {
            const auth = getAuth()
            if (auth && auth.accessToken) {
                config.headers.Authorization = `Bearer ${auth.accessToken}`
            }

            return config
        },
        (err: any) => Promise.reject(err)
    )

    // Response interceptor to handle 401 unauthorized responses
    axios.interceptors.response.use(
        (response: any) => {
            // Return successful responses as-is
            return response
        },
        (error: any) => {
            // Check if the error is a 401 Unauthorized
            if (error.response && error.response.status === 401) {
                // Show alert to user about session expiration
                alert(error.response.data.message)
                // Call the logout callback if it's available
                if (logoutCallback) {
                    logoutCallback()
                } else {
                    // Fallback: clear auth from localStorage if no callback is available
                    removeAuth()
                    // Optionally reload the page to redirect to login
                    window.location.reload()
                }
            }

            // Re-throw the error so it can still be handled by the calling code
            return Promise.reject(error)
        }
    )
}

export {
    getAuth,
    setAuth,
    removeAuth,
    AUTH_LOCAL_STORAGE_KEY,
    setLogoutCallback,
    clearLogoutCallback,
}
